export default __webpack_public_path__ + "static/media/Front-BBQ-house-in-Mozambique.991bdfc9.jpg";